import { Component, OnInit } from '@angular/core';
import { AppState } from '@app/reducers';
import { CrudService, CrudType,  IApplicationResponse, ModulesBasedApiSuffix, onActionSubmittedUtil, PERMISSION_RESTRICTION_ERROR, prepareGetRequestHttpParams, ResponseMessageTypes, ReusablePrimeNGTableFeatureService, RxjsService, SnackbarService, UserService } from '@app/shared';
import { PrimengDeleteConfirmDialogComponent } from '@app/shared/components/primeng-delete-confirm-dialog/primeng-delete-confirm-dialog.component';
import { DealerModuleApiSuffixModels, DealerTypeAddEditComponent, DEALER_COMPONENT } from '@modules/dealer';
import { UserLogin } from '@modules/others/models';
import { select, Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { PrimeNgTableVariablesModel } from '../../../../shared/models/prime-ng-table-list-component-variables.model';
import { handleNgrxStoreData, processStoreData } from '@app/shared/utils/combine-page-level.utils';
@Component({
  selector: 'app-dealer-type',
  templateUrl: './dealer-type-list.component.html'
})
export class DealerTypeListComponent extends PrimeNgTableVariablesModel implements OnInit {
  primengTableConfigProperties: any;
  row: any = {}
  loggedUser: any;
  first=0;

  constructor(private rxjsService: RxjsService, private crudService: CrudService, private store: Store<AppState>,
    private dialogService: DialogService, private snackbarService: SnackbarService, private userService: UserService,
    private reusablePrimeNGTableFeatureService: ReusablePrimeNGTableFeatureService) {
     super();
    this.primengTableConfigProperties = {
      tableCaption: "Dealer Type",
      breadCrumbItems: [{ displayName: 'Dealer Management', relativeRouterUrl: '' }, { displayName: 'Configuration', relativeRouterUrl: '' },{ displayName: 'Dealer Type ', relativeRouterUrl: '' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Dealer Type',
            dataKey: 'dealerTypeId',
            captionFontSize: '21px',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            checkBox: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'dealerTypeName', header: 'Dealer Type Name', width: '200px' },
              { field: 'description', header: 'Description', width: '200px' }
            ],
            enableMultiDeleteActionBtn: true,
            enableAddActionBtn: true,
            isDateWithTimeRequired: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER_TYPE_LIST,
            moduleName: ModulesBasedApiSuffix.DEALER,
          }
        ]
      }
    }
  }

  ngOnInit(): void {
    handleNgrxStoreData((response) => {
      let processData = processStoreData(response, this.primengTableConfigProperties, DEALER_COMPONENT.DEALER_TYPE);
      this.primengTableConfigProperties = processData.primengTableConfigProperties
      this.loggedInUserData = processData.loggedInUserData
    }, this.store);
    this.rxjsService.setGlobalLoaderProperty(false);
    this.getDealerTypeListData();
  }

  getDealerTypeListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    let dealerModuleApiSuffixModels: DealerModuleApiSuffixModels;
    dealerModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;

    this.crudService.get(
      this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
      dealerModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe((data: IApplicationResponse) => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.dataList = data.resources;
        this.totalRecords = data.totalCount;
      } else {
        this.dataList = null;
        this.totalRecords = 0;
      }
    })
  }


  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: any): void {
    switch (type) {
      case CrudType.CREATE:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].canCreate) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.first = row['pageIndex'] && row['pageSize'] ? row['pageIndex'] * row['pageSize'] : 0;
        this.getDealerTypeListData(row["pageIndex"], row["pageSize"], unknownVar)
        break;
      case CrudType.VIEW:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].canEdit) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        this.openAddEditPage(CrudType.VIEW, row);
        break;
        case CrudType.DELETE:
          if(this.selectedRows.length ==0){
           return this.snackbarService.openSnackbar("Please select atleast one item to delete", ResponseMessageTypes.WARNING);
          }
          if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].canRowDelete) {
            return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
          }else {
            this.onOneOrManyRowsDelete(row);
          }

          // this.reusablePrimeNGTableFeatureService.openDynamicDeleteDialog(this.selectedTabIndex, this.selectedRows,
          //   this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {

          //     if (result) {
          //       this.selectedRows = [];
          //       this.getDealerTypeListData();
          //     }
          //   });
          break;
      default:
    }
  }
  onOneOrManyRowsDelete(rowData?: object) {
    if (rowData) {
      var deletableIds = rowData[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey];
    } else {
      if (this.selectedRows.length > 0) {
        var deletableIds = []
        this.selectedRows.forEach((element: any) => {
          deletableIds.push(element[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey])
        });
      }
    }
    const ref = this.dialogService.open(PrimengDeleteConfirmDialogComponent, {
      showHeader: false,
      baseZIndex: 10000,
      width: '400px',
      data: {
        selectAll: (this.totalRecords == this.selectedRows.length) ? true : false,
        moduleName: this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
        apiSuffixModel: this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel,
        method: 'delete',
        dataObject: {
          ids: this.selectedRows.length > 0 ? deletableIds.join(',') : deletableIds,
          modifiedUserId: this.loggedInUserData.userId,
          isDeleted: true,
        }
      },
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result) => {
      if (result) {
        this.selectedRows = [];
        this.getDealerTypeListData();
      }
      this.userService.openedPrimeDialog = [];
    });
  }
  loadActionTypes(api, filter = true, editableObject?: any, type?: any) {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPopup('Create Dealer Type', editableObject, 'create');
        break;
      case CrudType.VIEW:
        switch (this.selectedTabIndex) {
          case 0:
            this.openAddEditPopup('Update Dealer Type', editableObject, 'view');
            break;
        }
        break;
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string, index?: number): void {
    this.loadActionTypes(null, false, editableObject, type);
  }

  openAddEditPopup(header, row, screen) {
    const rowData = { ...row };
    const ref = this.dialogService.open(DealerTypeAddEditComponent, {
      header: header,
      baseZIndex: 1000,
      width: '650px',
      closable: false,
      showHeader: false,
      data: {
        createdUserId: this.loggedInUserData ? this.loggedInUserData?.userId : null,
        row: rowData,
        screen: screen
      },
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((res: IApplicationResponse) => {
      if (res?.isSuccess && res?.statusCode == 200) {
        let row = {pageIndex:0, pageSize:10};
        this.onCRUDRequested('get',row);
        this.first=0;
      }
      this.userService.openedPrimeDialog = [];
    });
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }
}
